/**
 * Internal ID for the bundled order-book scalper (`reduceScalperPaper` + optional live Lightning).
 * Listed under Built-in in the Dashboard preset picker.
 */
export const BUILTIN_SCALPER_PRESET_ID = "unt-builtin-scalper";
export const BUILTIN_REVIVAL_HUNTER_PRESET_ID = "unt-revival-hunter";

/** Extensible shape if you ship curated presets again later. */
export type BuiltinAlgoPreset = {
  id: string;
  name: string;
  description: string;
  detail: string;
  tags: string[];
};

/** Curated catalog presets (optional); the runnable scalper uses `BUILTIN_SCALPER_PRESET_ID` in the picker. */
export const BUILTIN_ALGO_PRESETS: BuiltinAlgoPreset[] = [
  {
    id: BUILTIN_REVIVAL_HUNTER_PRESET_ID,
    name: "Revival Hunter",
    description: "Snipes tokens graduating or reviving in the Nursery with high volume acceleration.",
    detail: "Watches for Nursery revival scores > 1.5 and waits for a catalyst buy confirmation on the live tape.",
    tags: ["nursery", "momentum", "revival"],
  }
];
